import { Component, Inject, OnDestroy, OnInit , Input} from '@angular/core';
import { Store } from '@src/store';
// import { projectActions } from "../../../../store/reducers/projectReducer";


@Component({
    selector: 'assign-schemas',
    template: require('./assignSchemas.html'),
    styles: [require('./_assignSchemas.scss')]
})

export class AssignSchemasComponent implements OnInit , OnDestroy {

       @Input() public projectData;

        public boxes:any;
        public envTypeTest:any
        public objectsArray:any
        public isLockMainPath = false;
        public _selectedProjectGroup = null;
        public placeHolderProjectGroup :any;
        public unsubscribe:any
        public envConfig = {
            showMenu: false,
            showVersion: false,
            showDateTime: false,
            showProgress: false
        };
        public _selectedTemplateId:any
        public databaseType:any
        public currEnvTypeIndex:any
        public showSchemaSettings:boolean


    constructor(@Inject('$filter') private $filter: any ,@Inject('$scope') public $scope: any, public store : Store, @Inject('$state') public state: any,@Inject('$stateParams') public $stateParams: any) {
        this.databaseType = this.$filter('dbTypeItem')(["Schemas"], this.state.params.dbType);
  
    }

    // this.onChangeHost.emit({ hostselected: this.selectedHost,
    //     unmangeSchemasByHostList: this.unmangeSchemasByHostList })

    ngOnInit() {
        this.currEnvTypeIndex = 0;
        if (this.state.params.continued == null || this.state.params.continued == false){
            this.state.go('app.authorized.projectWizard.settings', { id : this.state.params.id, step : 1 });
        }

    }

    onEnvTypeClick() {
        this.showSchemaSettings = true;
    }

    rotateLeft() {
        // if (this.currEnvTypeIndex == 0) {
        //     this.showSchemaSettings = false;
        // } else {
            if(this.currEnvTypeIndex == 0)
                this.currEnvTypeIndex = this.boxes.length - 1 - this.currEnvTypeIndex;
            else
                this.currEnvTypeIndex = (--this.currEnvTypeIndex) % this.boxes.length;
        // }
    }

    rotateRight() {
        // if (this.envTypeTest && this.currEnvTypeIndex <= this.selectedEnvTypes.length - 1)
            // this.currEnvTypeIndex++;
        // else if (this.currEnvTypeIndex < this.selectedEnvTypes.length - 1) {
            // this.currEnvTypeIndex++;
       // }
       this.currEnvTypeIndex = (++this.currEnvTypeIndex) % this.boxes.length;

    }

    onClose() {
        this.showSchemaSettings = false;
    }

    get selectedEnvTypes () {
        if (this.projectData) {
            if (!this.envTypeTest || this.envTypeTest.length == 0) {
                this.envTypeTest = this.projectData.environmentTypes.filter(item => item.id == 8)[0]
                if (this.envTypeTest && this.envTypeTest.environments && this.envTypeTest.environments[0]) {
                    this.envTypeTest.environments[0].isTest = true;
                }
            }
            const envTypes = this.projectData.environmentTypes.filter(item => item.selected && item.id != 8);
            this.boxes = this.projectData.environmentTypes.filter(item => item.selected)
            return envTypes;
        }
        return [];
    }

    envTypeClicked($index) {
        let targetIndex = $index;
        let selectedEnvType = this.boxes[targetIndex];
        if (!selectedEnvType.isRMSource) {
            // CHECK IF RM SOURCE IS ALREADY HAVE AT LEAST ONE SCHEMA
            let rmSourceEnvType = this.boxes.filter(i => i.isRMSource)[0];
            let rmSourceEnv = rmSourceEnvType.environments[0];
            if (rmSourceEnv.schemas == null || rmSourceEnv.schemas.length == 0) {
                targetIndex = this.boxes.indexOf(rmSourceEnvType);


                
                // targetIndex = this.selectedEnvTypes.indexOf(rmSourceEnvType);
                // if (this.envTypeTest && selectedEnvType.id == 2)
                //     targetIndex = 2;
            }
        }
        // if (this.envTypeTest && selectedEnvType.id != 2 ) { // 2 is dev env
        //     targetIndex = targetIndex + 1;
        // }
        this.currEnvTypeIndex = targetIndex;
        this.showSchemaSettings = true;
    }

    envClicked(data,$index) {
        if (this.envTypeTest && $index > 0  && data.envTypeId != 8 ) // 8 is test env
            $index = $index + 1;
        let targetIndex = $index;
        let selectedEnvType = ($index == this.selectedEnvTypes.length) ? this.selectedEnvTypes[$index - 1] : this.selectedEnvTypes[$index];
         let rmSourceEnvType = this.selectedEnvTypes.filter(i => i.isRMSource)[0];
         let rmSourceEnv = rmSourceEnvType.environments[0];
         if (rmSourceEnv.schemas == null || rmSourceEnv.schemas.length == 0) {
            targetIndex = this.selectedEnvTypes.indexOf(rmSourceEnvType);
             if (this.envTypeTest) {
                 targetIndex = targetIndex + 1;
                 this.currEnvTypeIndex = targetIndex;
                 this.showSchemaSettings = true;
                 return;
             }
         }
         if ($index == 0 && selectedEnvType.isRMSource && this.envTypeTest && data.envTypeId == 4) // 4 is RS env
            targetIndex = targetIndex + 1;
         this.currEnvTypeIndex = targetIndex;
         this.showSchemaSettings = true;
    }

    ngOnDestroy(): void {}


    
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/projectWizard/assignSchemas-ang7/assignSchemas.ts